//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ActividadesAPI from '@/api/promotores/usuarios/actividades.api'
import ListSkeleton from "@/components/Skeletons/ListSkeleton.vue";
import groupBy from 'lodash/groupBy'
import moment from "moment"

export default {
  components: { ListSkeleton },
  data: () => ({
    actividades: [],
    page: 0,
    pages: 0,
    loading: false,
  }),

  computed: {
    grupos() {
      return groupBy(this.actividades, (actividad) => moment(actividad.created_at).format('YYYY-MM-DD'))
    }
  },

  mounted() {
    this.loadActividades()
  },

  methods: {
    async loadActividades(page = 1) {
      try {
        this.loading = true
        const { data, current_page, last_page } = await ActividadesAPI.all(this.$route.params.promotor, { page })

        this.page = current_page
        this.pages = last_page

        this.actividades = data
      } finally {
        this.loading = false
      }
    }
  }
}
